import { YesNoFilter } from 'app/form-fields/common/register/filters/yes-no/yes-no-filter';
import { YesNoFilterComponent } from 'app/form-fields/common/register/filters/yes-no/yes-no-filter.component';
import { YesNoTextInputFilter } from 'app/form-fields/common/register/filters/yes-no/yes-no-text-input-filter';
import { FieldWeb } from 'app/shared/model/item.model';

import { LabelFormFieldHeaderColumn } from './label-form-field-header-column';
import { LabelHeaderColumn } from './label-header-column';
import { FormFieldHeader } from '../../common/register/form-field-header/form-field-header';

export class YesNoHeader extends FormFieldHeader {
  constructor(item: FieldWeb) {
    super(item);

    this.columns = [];

    const yesNoColumn = new LabelFormFieldHeaderColumn(item);
    yesNoColumn.filter = new YesNoFilter(item, YesNoFilterComponent);
    this.columns.push(yesNoColumn);

    if (item.hasTextInput) {
      const yesNoTextColumn = new LabelHeaderColumn(item);
      this.columns.push(yesNoTextColumn);
    }

    const [yesNo, textInput] = this.columns.map((column) => column.filter);
    this.filter = new YesNoTextInputFilter(yesNo, textInput);
  }
}
